import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar/navbar";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import { useHistory } from "react-router-dom";

import {
  Box,
  Typography,
  Button,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Card,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CakeIcon from "@mui/icons-material/Cake";

import {
  collection,
  addDoc,
  getDocs,
  serverTimestamp,
  updateDoc,
  doc,
  query,
  where,
  orderBy,
  limit
} from "firebase/firestore";

import { auth, db } from "../Config/firebase";
import EditIcon from "@mui/icons-material/Edit";

import {
  consultaTenantAtual,
  aplicarTenantAtual
} from "../Utils/tenant";


/* =========================================================
   FUNÇÕES AUXILIARES
========================================================= */

function formatarDataBR(dataISO) {
  if (!dataISO) return "";

  const [ano, mes, dia] = dataISO.split("-");

  return `${dia}/${mes}/${ano}`;
}

function calcularPrazoAniversario(dataNascimento) {
  if (!dataNascimento) return "Data não informada";

  const partes = dataNascimento.split("-").map(Number);
  if (partes.length !== 3 || partes.some(Number.isNaN)) return "Data inválida";

  const [, mes, dia] = partes;
  const agora = new Date();
  const hoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());
  const aniversario = new Date(agora.getFullYear(), mes - 1, dia);

  if (aniversario < hoje) return "Só ano que vem agora";

  const diasRestantes = Math.round(
    (aniversario.getTime() - hoje.getTime()) / 86400000
  );

  if (diasRestantes === 0) return "Hoje";
  if (diasRestantes === 1) return "1 dia";
  return `${diasRestantes} dias`;
}


/* =========================================================
   COMPONENT
========================================================= */

export default function CadastroDP() {

  const { salvandoCadastro, executarSalvamento } =
    useEstadoSalvamento();

  const history = useHistory();


  /* =========================================================
     ESTADOS
  ========================================================= */

  const [ultimosPeriodos, setUltimosPeriodos] =
    useState({});

  const [dialogPeriodo, setDialogPeriodo] =
    useState(false);

  const [prestadorSelecionado, setPrestadorSelecionado] =
    useState(null);


  const [novoPeriodo, setNovoPeriodo] = useState({
    periodoInicial: "",
    periodoFinal: ""
  });


  const [dialogHistorico, setDialogHistorico] =
    useState(false);

  const [historico, setHistorico] =
    useState([]);


  const [filtroStatus, setFiltroStatus] =
    useState("ativo");


  const [funcionarios, setFuncionarios] =
    useState([]);

  const [usuarios, setUsuarios] =
    useState([]);


  const [filtroNome, setFiltroNome] =
    useState("");


  const [dialogFuncionario, setDialogFuncionario] =
    useState(false);

  const [dialogAniversarios, setDialogAniversarios] =
    useState(false);


  const [novoFuncionario, setNovoFuncionario] = useState({
    nome: "",
    cargo: "",
    tipo: "funcionario",

    // FUNCIONÁRIO
    dataNascimento: "",
    usuarioId: "",
    dataAdmissao: "",
    dataDemissao: "",

    // PRESTADOR
    periodoInicial: "",
    periodoFinal: ""
  });


  const [dialogEditar, setDialogEditar] =
    useState(false);

  const [funcionarioEditando, setFuncionarioEditando] =
    useState(null);


  const [modoEdicao, setModoEdicao] =
    useState(false);

  const [idEditando, setIdEditando] =
    useState(null);


  /* =========================================================
     BUSCAR ÚLTIMO PERÍODO DO PRESTADOR
  ========================================================= */

  async function buscarUltimoPeriodo(prestadorId) {

    const q = query(
      collection(db, "dp_prestacoes"),
      where("prestadorId", "==", prestadorId),
      orderBy("createdAt", "desc"),
      limit(1)
    );

    const snap =
      await getDocs(consultaTenantAtual(q));

    if (!snap.empty) {
      return snap.docs[0].data();
    }

    return null;
  }


  /* =========================================================
     ABRIR NOVO PERÍODO
  ========================================================= */

  async function abrirNovoPeriodo(func) {

    setPrestadorSelecionado(func);

    const q = query(
      collection(db, "dp_prestacoes"),
      where("prestadorId", "==", func.id),
      orderBy("createdAt", "desc"),
      limit(1)
    );

    const snap =
      await getDocs(consultaTenantAtual(q));


    if (!snap.empty) {

      const ultimo =
        snap.docs[0].data();


      // Existe período ativo
      if (!ultimo.periodoFinal) {

        setNovoPeriodo({
          periodoInicial:
            ultimo.periodoInicial || "",

          periodoFinal:
            ultimo.periodoFinal || ""
        });

        setDialogPeriodo(true);

        return;
      }
    }


    // Novo período
    setNovoPeriodo({
      periodoInicial: "",
      periodoFinal: ""
    });

    setDialogPeriodo(true);
  }


  /* =========================================================
     SALVAR PERÍODO
  ========================================================= */

  async function salvarPeriodo() {

    if (
      !novoPeriodo.periodoInicial ||
      !prestadorSelecionado
    ) {
      return;
    }


    const q = query(
      collection(db, "dp_prestacoes"),
      where(
        "prestadorId",
        "==",
        prestadorSelecionado.id
      ),
      orderBy("createdAt", "desc"),
      limit(1)
    );


    const snap =
      await getDocs(consultaTenantAtual(q));


    /* -------------------------------------------------------
       JÁ EXISTE PERÍODO
    ------------------------------------------------------- */

    if (!snap.empty) {

      const ultimoDoc =
        snap.docs[0];

      const ultimo =
        ultimoDoc.data();


      // Período ainda ativo
      if (!ultimo.periodoFinal) {

        await updateDoc(
          doc(
            db,
            "dp_prestacoes",
            ultimoDoc.id
          ),
          {
            periodoInicial:
              novoPeriodo.periodoInicial,

            periodoFinal:
              novoPeriodo.periodoFinal || null,

            atualizadoPorEmail:
              auth.currentUser?.email || ""
          }
        );

      }

      // Último período já encerrado
      else {

        await addDoc(
          collection(db, "dp_prestacoes"),
          aplicarTenantAtual({
            prestadorId:
              prestadorSelecionado.id,

            periodoInicial:
              novoPeriodo.periodoInicial,

            periodoFinal:
              novoPeriodo.periodoFinal || null,

            criadoPorEmail:
              auth.currentUser?.email || "",

            createdAt:
              serverTimestamp()
          })
        );
      }

    }

    /* -------------------------------------------------------
       PRIMEIRO PERÍODO
    ------------------------------------------------------- */

    else {

      await addDoc(
        collection(db, "dp_prestacoes"),
        aplicarTenantAtual({

          prestadorId:
            prestadorSelecionado.id,

          periodoInicial:
            novoPeriodo.periodoInicial,

          periodoFinal:
            novoPeriodo.periodoFinal || null,

          criadoPorEmail:
            auth.currentUser?.email || "",

          createdAt:
            serverTimestamp()
        })
      );
    }


    /* -------------------------------------------------------
       ATUALIZA STATUS DO PRESTADOR
    ------------------------------------------------------- */

    await updateDoc(
      doc(
        db,
        "dp_funcionarios",
        prestadorSelecionado.id
      ),
      {
        periodoFinal:
          novoPeriodo.periodoFinal || null,

        ativo:
          !novoPeriodo.periodoFinal
      }
    );


    setDialogPeriodo(false);

    setPrestadorSelecionado(null);

    await carregarFuncionarios();
  }


  /* =========================================================
     HISTÓRICO
  ========================================================= */

  async function abrirHistorico(func) {

    setPrestadorSelecionado(func);

    const q = query(
      collection(db, "dp_prestacoes"),
      where(
        "prestadorId",
        "==",
        func.id
      ),
      orderBy("createdAt", "desc")
    );


    const snap =
      await getDocs(
        consultaTenantAtual(q)
      );


    setHistorico(
      snap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }))
    );


    setDialogHistorico(true);
  }


  /* =========================================================
     CARREGAR FUNCIONÁRIOS
  ========================================================= */

  useEffect(() => {
    carregarFuncionarios();
    carregarUsuarios();
  }, []);


  async function carregarUsuarios() {
    const snap = await getDocs(
      consultaTenantAtual(
        query(
          collection(db, "users"),
          orderBy("nome", "asc")
        )
      )
    );

    setUsuarios(
      snap.docs.map(item => ({ id: item.id, ...item.data() }))
    );
  }


  async function carregarFuncionarios() {

    const snap =
      await getDocs(
        consultaTenantAtual(
          collection(
            db,
            "dp_funcionarios"
          )
        )
      );


    const lista =
      snap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }));


    setFuncionarios(lista);


    /* -------------------------------------------------------
       BUSCAR ÚLTIMO PERÍODO DOS PRESTADORES
    ------------------------------------------------------- */

    const periodos = {};


    for (const func of lista) {

      if (func.tipo === "prestador") {

        const ultimo =
          await buscarUltimoPeriodo(
            func.id
          );


        if (ultimo) {
          periodos[func.id] =
            ultimo;
        }
      }
    }


    setUltimosPeriodos(periodos);
  }


  /* =========================================================
     SALVAR FUNCIONÁRIO / PRESTADOR
  ========================================================= */

  async function salvarFuncionario() {

    if (!novoFuncionario.nome) {
      return;
    }


    /* -------------------------------------------------------
       VALIDAÇÃO FUNCIONÁRIO
    ------------------------------------------------------- */

    if (
      novoFuncionario.tipo === "funcionario" &&
      !novoFuncionario.dataAdmissao
    ) {
      return;
    }

    const usuarioJaVinculado = novoFuncionario.usuarioId && funcionarios.some(
      item => item.usuarioId === novoFuncionario.usuarioId && item.id !== idEditando
    );

    if (usuarioJaVinculado) {
      alert("Este usuário já está vinculado a outro funcionário.");
      return;
    }


    /* -------------------------------------------------------
       VALIDAÇÃO PRESTADOR
    ------------------------------------------------------- */

    if (
      novoFuncionario.tipo === "prestador" &&
      !novoFuncionario.periodoInicial
    ) {
      return;
    }


    /* =======================================================
       EDITAR
    ======================================================= */

    if (modoEdicao) {

      /* -----------------------------------------------------
         ATUALIZA CADASTRO PRINCIPAL
      ----------------------------------------------------- */

      await updateDoc(
        doc(
          db,
          "dp_funcionarios",
          idEditando
        ),
        {

          nome:
            novoFuncionario.nome,

          cargo:
            novoFuncionario.cargo,

          tipo:
            novoFuncionario.tipo,

          dataNascimento:
            novoFuncionario.tipo === "funcionario"
              ? novoFuncionario.dataNascimento || null
              : null,

          usuarioId:
            novoFuncionario.tipo === "funcionario"
              ? novoFuncionario.usuarioId || null
              : null,


          dataAdmissao:
            novoFuncionario.tipo === "funcionario"
              ? novoFuncionario.dataAdmissao
              : null,


          dataDemissao:
            novoFuncionario.tipo === "funcionario"
              ? novoFuncionario.dataDemissao || null
              : null,


          periodoFinal:
            novoFuncionario.tipo === "prestador"
              ? novoFuncionario.periodoFinal || null
              : null,


          ativo:
            novoFuncionario.tipo === "funcionario"
              ? !novoFuncionario.dataDemissao
              : !novoFuncionario.periodoFinal
        }
      );


      /* =====================================================
         SE FOR PRESTADOR
      ===================================================== */

      if (
        novoFuncionario.tipo === "prestador"
      ) {

        const q = query(
          collection(db, "dp_prestacoes"),
          where(
            "prestadorId",
            "==",
            idEditando
          ),
          orderBy(
            "createdAt",
            "desc"
          ),
          limit(1)
        );


        const snap =
          await getDocs(
            consultaTenantAtual(q)
          );


        /* ---------------------------------------------------
           JÁ EXISTE PERÍODO
        --------------------------------------------------- */

        if (!snap.empty) {

          const docRef =
            doc(
              db,
              "dp_prestacoes",
              snap.docs[0].id
            );


          await updateDoc(
            docRef,
            {

              periodoInicial:
                novoFuncionario.periodoInicial,

              periodoFinal:
                novoFuncionario.periodoFinal || null,

              atualizadoPorEmail:
                auth.currentUser?.email || ""
            }
          );

        }


        /* ---------------------------------------------------
           NÃO EXISTE PERÍODO
        --------------------------------------------------- */

        else {

          await addDoc(
            collection(
              db,
              "dp_prestacoes"
            ),
            aplicarTenantAtual({

              prestadorId:
                idEditando,

              periodoInicial:
                novoFuncionario.periodoInicial,

              periodoFinal:
                novoFuncionario.periodoFinal || null,

              criadoPorEmail:
                auth.currentUser?.email || "",

              createdAt:
                serverTimestamp()
            })
          );
        }
      }


      /* =====================================================
         SE ALTEROU PRESTADOR PARA FUNCIONÁRIO
      ===================================================== */

      if (
        novoFuncionario.tipo === "funcionario"
      ) {

        await updateDoc(
          doc(
            db,
            "dp_funcionarios",
            idEditando
          ),
          {
            periodoFinal: null
          }
        );
      }
    }


    /* =======================================================
       NOVO CADASTRO
    ======================================================= */

    else {

      let ativo = true;


      if (
        novoFuncionario.tipo === "funcionario"
      ) {

        ativo =
          !novoFuncionario.dataDemissao;
      }

      else {

        ativo =
          !novoFuncionario.periodoFinal;
      }


      /* -----------------------------------------------------
         CRIAR FUNCIONÁRIO
      ----------------------------------------------------- */

      const novoDoc =
        await addDoc(
          collection(
            db,
            "dp_funcionarios"
          ),
          aplicarTenantAtual({

            nome:
              novoFuncionario.nome,

            cargo:
              novoFuncionario.cargo,

            tipo:
              novoFuncionario.tipo,

            dataNascimento:
              novoFuncionario.tipo === "funcionario"
                ? novoFuncionario.dataNascimento || null
                : null,

            usuarioId:
              novoFuncionario.tipo === "funcionario"
                ? novoFuncionario.usuarioId || null
                : null,


            dataAdmissao:
              novoFuncionario.tipo === "funcionario"
                ? novoFuncionario.dataAdmissao
                : null,


            dataDemissao:
              novoFuncionario.tipo === "funcionario"
                ? novoFuncionario.dataDemissao || null
                : null,


            periodoFinal:
              novoFuncionario.tipo === "prestador"
                ? novoFuncionario.periodoFinal || null
                : null,


            ativo,

            createdAt:
              serverTimestamp()
          })
        );


      /* =====================================================
         SE FOR PRESTADOR, CRIAR PRIMEIRO PERÍODO
      ===================================================== */

      if (
        novoFuncionario.tipo === "prestador"
      ) {

        await addDoc(
          collection(
            db,
            "dp_prestacoes"
          ),
          aplicarTenantAtual({

            prestadorId:
              novoDoc.id,

            periodoInicial:
              novoFuncionario.periodoInicial,

            periodoFinal:
              novoFuncionario.periodoFinal || null,

            criadoPorEmail:
              auth.currentUser?.email || "",

            createdAt:
              serverTimestamp()
          })
        );
      }
    }


    /* =======================================================
       LIMPAR FORMULÁRIO
    ======================================================= */

    setDialogFuncionario(false);

    setModoEdicao(false);

    setIdEditando(null);


    setNovoFuncionario({
      nome: "",
      cargo: "",
      tipo: "funcionario",
      dataNascimento: "",
      usuarioId: "",
      dataAdmissao: "",
      dataDemissao: "",
      periodoInicial: "",
      periodoFinal: ""
    });


    await carregarFuncionarios();
  }


  /* =========================================================
     FILTRO
  ========================================================= */

  const funcionariosFiltrados =
    funcionarios

      .filter(f => {

        const nomeMatch =
          contemTextoPesquisa(
            (f.nome || "").toLowerCase(),
            filtroNome.toLowerCase()
          );


        const ativo =
          f.tipo === "funcionario"
            ? !f.dataDemissao
            : !f.periodoFinal;


        if (
          filtroStatus === "ativo"
        ) {

          return (
            nomeMatch &&
            ativo
          );
        }


        if (
          filtroStatus === "inativo"
        ) {

          return (
            nomeMatch &&
            !ativo
          );
        }


        return nomeMatch;
      })


      .sort((a, b) =>
        (a.nome || "").localeCompare(
          b.nome || "",
          "pt-BR"
        )
      );


  /* =========================================================
     SEPARAR FUNCIONÁRIOS E PRESTADORES
  ========================================================= */

  const funcionariosCadastrados =
    funcionariosFiltrados.filter(
      f =>
        f.tipo === "funcionario"
    );


  const prestadoresCadastrados =
    funcionariosFiltrados.filter(
      f =>
        f.tipo === "prestador"
    );


  /* =========================================================
     SALVAR EDIÇÃO DE TIPO
  ========================================================= */

  async function salvarEdicao() {

    if (!funcionarioEditando) {
      return;
    }


    await updateDoc(
      doc(
        db,
        "dp_funcionarios",
        funcionarioEditando.id
      ),
      {
        tipo:
          funcionarioEditando.tipo
      }
    );


    setDialogEditar(false);

    setFuncionarioEditando(null);

    await carregarFuncionarios();
  }


  /* =========================================================
     FORMULÁRIO LIMPO PARA NOVO
  ========================================================= */

  function abrirNovoCadastro() {

    setModoEdicao(false);

    setIdEditando(null);


    setNovoFuncionario({
      nome: "",
      cargo: "",
      tipo: "funcionario",
      dataNascimento: "",
      usuarioId: "",
      dataAdmissao: "",
      dataDemissao: "",
      periodoInicial: "",
      periodoFinal: ""
    });


    setDialogFuncionario(true);
  }


  /* =========================================================
     RENDER CARD
  ========================================================= */

  function renderCard(func) {

    const ativo =
      func.tipo === "funcionario"
        ? !func.dataDemissao
        : !func.periodoFinal;


    return (

      <Card
        key={func.id}
        sx={{
          mb: 1,
          px: 2,
          py: 1,
          cursor: "pointer",
          "&:hover": {
            backgroundColor:
              "action.hover"
          }
        }}

        onClick={() =>
          history.push(
            `/cadastro-funcionario/${func.id}`
          )
        }
      >

        <Stack
          direction="row"
          alignItems="center"
          sx={{
            width: "100%"
          }}
        >

          <Box
            sx={{
              display: "flex",
              gap: 1.5,
              flexGrow: 1,
              alignItems: "center"
            }}
          >

            <Typography
              fontWeight={600}
              fontSize={14}
            >
              {func.nome}
            </Typography>


            <Typography
              color="text.secondary"
              fontSize={13}
            >
              {func.cargo}
            </Typography>


            <Typography
              fontSize={13}
              color={
                ativo
                  ? "success.main"
                  : "error.main"
              }
            >
              {ativo
                ? "Ativo"
                : "Inativo"}
            </Typography>


            <Typography
              color="text.secondary"
              fontSize={13}
            >

              {func.tipo === "funcionario"

                ? `Admissão: ${formatarDataBR(
                    func.dataAdmissao
                  )}`

                : (() => {

                    const p =
                      ultimosPeriodos[
                        func.id
                      ];


                    if (!p) {
                      return "Período: -";
                    }


                    return (
                      `Período: ${formatarDataBR(
                        p.periodoInicial
                      )}` +

                      (
                        p.periodoFinal
                          ? " até " +
                            formatarDataBR(
                              p.periodoFinal
                            )
                          : ""
                      )
                    );

                  })()

              }

            </Typography>


            <Typography
              fontSize={13}
              color="primary"
            >
              {func.tipo === "prestador"
                ? "Prestador"
                : "Funcionário"}
            </Typography>

          </Box>


          {/* =================================================
              BOTÕES DO PRESTADOR
          ================================================= */}

          {func.tipo === "prestador" && (

            <>

              <Button
                size="small"
                onClick={(e) => {

                  e.stopPropagation();

                  abrirNovoPeriodo(func);

                }}
              >
                + Período
              </Button>


              <Button
                size="small"
                onClick={(e) => {

                  e.stopPropagation();

                  abrirHistorico(func);

                }}
              >
                Histórico
              </Button>

            </>

          )}


          {/* =================================================
              EDITAR
          ================================================= */}

          <Button
            size="small"
            sx={{
              ml: "auto"
            }}

            onClick={async (e) => {

              e.stopPropagation();


              let periodoInicial = "";

              let periodoFinal = "";


              if (
                func.tipo === "prestador"
              ) {

                const ultimoPeriodo =
                  await buscarUltimoPeriodo(
                    func.id
                  );


                if (ultimoPeriodo) {

                  periodoInicial =
                    ultimoPeriodo.periodoInicial ||
                    "";

                  periodoFinal =
                    ultimoPeriodo.periodoFinal ||
                    "";
                }
              }


              setNovoFuncionario({

                nome:
                  func.nome || "",

                cargo:
                  func.cargo || "",

                tipo:
                  func.tipo ||
                  "funcionario",

                dataNascimento:
                  func.dataNascimento || "",

                usuarioId:
                  func.usuarioId || "",

                dataAdmissao:
                  func.dataAdmissao || "",

                dataDemissao:
                  func.dataDemissao || "",

                periodoInicial,

                periodoFinal
              });


              setModoEdicao(true);

              setIdEditando(func.id);

              setDialogFuncionario(true);
            }}
          >

            <EditIcon
              fontSize="small"
            />

          </Button>

        </Stack>

      </Card>
    );
  }


  /* =========================================================
     RENDER PRINCIPAL
  ========================================================= */

  return (

    <Box>

      <Navbar />


      <Box p={3}>

        {/* ===================================================
            CABEÇALHO
        =================================================== */}

        <Box
          className="cabecalho-lista-cadastro cabecalho-exportar-lista"
        >

          <Typography
            variant="h4"
            mb={3}
          >
            Departamento Pessoal
          </Typography>


          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{
              mb: 3
            }}
          >

            <Button
              variant="contained"
              size="large"
              startIcon={<AddIcon />}
              onClick={abrirNovoCadastro}
            >
              Novo
            </Button>


            <TextField
              size="large"
              label="Pesquisar colaborador"
              fullWidth
              value={filtroNome}
              onChange={(e) =>
                setFiltroNome(
                  e.target.value
                )
              }
            />


            <TextField
              select
              label="Status"
              value={filtroStatus}
              onChange={(e) =>
                setFiltroStatus(
                  e.target.value
                )
              }
              sx={{
                minWidth: 150
              }}
            >

              <MenuItem value="ativo">
                Ativos
              </MenuItem>

              <MenuItem value="inativo">
                Inativos
              </MenuItem>

              <MenuItem value="todos">
                Todos
              </MenuItem>

            </TextField>

            <Button
              variant="outlined"
              startIcon={<CakeIcon />}
              onClick={() => setDialogAniversarios(true)}
              sx={{ whiteSpace: "nowrap", minWidth: 210, height: 40 }}
            >
              Datas de aniversário
            </Button>

          </Stack>

        </Box>


        {/* ===================================================
            FUNCIONÁRIOS
        =================================================== */}

        <Typography
          variant="h5"
          sx={{
            mt: 2,
            mb: 2,
            fontWeight: 600
          }}
        >
          Funcionários cadastrados
        </Typography>


        {funcionariosCadastrados.length === 0 ? (

          <Typography
            color="text.secondary"
            sx={{
              mb: 3
            }}
          >
            Nenhum funcionário cadastrado.
          </Typography>

        ) : (

          <Box sx={{ mb: 4 }}>

            {funcionariosCadastrados.map(
              func =>
                renderCard(func)
            )}

          </Box>

        )}


        {/* ===================================================
            PRESTADORES
        =================================================== */}

        <Typography
          variant="h5"
          sx={{
            mt: 3,
            mb: 2,
            fontWeight: 600
          }}
        >
          Prestadores de serviço cadastrados
        </Typography>


        {prestadoresCadastrados.length === 0 ? (

          <Typography
            color="text.secondary"
          >
            Nenhum prestador de serviço cadastrado.
          </Typography>

        ) : (

          <Box>

            {prestadoresCadastrados.map(
              func =>
                renderCard(func)
            )}

          </Box>

        )}

      </Box>

      <Dialog
        open={dialogAniversarios}
        onClose={() => setDialogAniversarios(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Datas de aniversário</DialogTitle>
        <DialogContent>
          <TableContainer sx={{ mt: 1 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Funcionário</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Data de nascimento</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Dias para o aniversário</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {funcionarios
                  .filter(item => item.tipo === "funcionario" && !item.dataDemissao)
                  .sort((a, b) => String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR"))
                  .map(item => (
                    <TableRow key={item.id}>
                      <TableCell>{item.nome || "-"}</TableCell>
                      <TableCell>{item.dataNascimento ? formatarDataBR(item.dataNascimento) : "Não informada"}</TableCell>
                      <TableCell>{calcularPrazoAniversario(item.dataNascimento)}</TableCell>
                    </TableRow>
                  ))}
                {funcionarios.filter(item => item.tipo === "funcionario" && !item.dataDemissao).length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      Nenhum funcionário cadastrado.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogAniversarios(false)}>Fechar</Button>
        </DialogActions>
      </Dialog>


      {/* =====================================================
          DIALOG NOVO PERÍODO
      ===================================================== */}

      <Dialog
        open={dialogPeriodo}
        onClose={() =>
          !salvandoCadastro &&
          setDialogPeriodo(false)
        }
      >

        <DialogTitle>
          Novo Período
        </DialogTitle>


        <DialogContent>

          <TextField
            label="Período Inicial"
            type="date"
            fullWidth
            margin="dense"
            InputLabelProps={{
              shrink: true
            }}
            value={
              novoPeriodo.periodoInicial
            }
            onChange={(e) =>
              setNovoPeriodo({
                ...novoPeriodo,
                periodoInicial:
                  e.target.value
              })
            }
          />


          <TextField
            label="Período Final"
            type="date"
            fullWidth
            margin="dense"
            InputLabelProps={{
              shrink: true
            }}
            value={
              novoPeriodo.periodoFinal
            }
            onChange={(e) =>
              setNovoPeriodo({
                ...novoPeriodo,
                periodoFinal:
                  e.target.value
              })
            }
          />

        </DialogContent>


        <DialogActions>

          <Button
            onClick={() =>
              setDialogPeriodo(false)
            }
            disabled={salvandoCadastro}
          >
            Cancelar
          </Button>


          <Button
            variant="contained"
            onClick={() =>
              executarSalvamento(
                salvarPeriodo
              )
            }
            disabled={salvandoCadastro}
          >
            {salvandoCadastro
              ? "Salvando..."
              : "Salvar"}
          </Button>

        </DialogActions>

      </Dialog>


      {/* =====================================================
          DIALOG HISTÓRICO
      ===================================================== */}

      <Dialog
        open={dialogHistorico}
        onClose={() =>
          setDialogHistorico(false)
        }
        fullWidth
      >

        <DialogTitle>
          Histórico de Períodos
        </DialogTitle>


        <DialogContent>

          {historico.length === 0 ? (

            <Typography
              color="text.secondary"
            >
              Nenhum período cadastrado.
            </Typography>

          ) : (

            historico.map((p, i) => (

              <Box
                key={p.id || i}
                sx={{
                  mb: 1.5
                }}
              >

                <Typography>

                  {formatarDataBR(
                    p.periodoInicial
                  )}

                  {" "}

                  {p.periodoFinal !== null &&
                  p.periodoFinal !== "" ? (

                    "até " +
                    formatarDataBR(
                      p.periodoFinal
                    )

                  ) : (

                    "(ativo)"

                  )}

                </Typography>


                <Typography
                  variant="body2"
                  color="text.secondary"
                >

                  Responsável:{" "}

                  {p.atualizadoPorEmail ||
                    p.criadoPorEmail ||
                    "Usuário não identificado"}

                </Typography>

              </Box>

            ))

          )}

        </DialogContent>

      </Dialog>


      {/* =====================================================
          DIALOG EDITAR TIPO
          Mantido caso seja utilizado em outra parte.
      ===================================================== */}

      <Dialog
        open={dialogEditar}
        onClose={() =>
          !salvandoCadastro &&
          setDialogEditar(false)
        }
        fullWidth
        maxWidth="xs"
      >

        <DialogTitle>
          Editar Tipo
        </DialogTitle>


        <DialogContent>

          <TextField
            select
            label="Tipo"
            fullWidth
            margin="dense"
            value={
              funcionarioEditando?.tipo ||
              ""
            }
            onChange={(e) =>
              setFuncionarioEditando({
                ...funcionarioEditando,
                tipo: e.target.value
              })
            }
          >

            <MenuItem value="funcionario">
              Funcionário
            </MenuItem>

            <MenuItem value="prestador">
              Prestador
            </MenuItem>

          </TextField>

        </DialogContent>


        <DialogActions>

          <Button
            onClick={() =>
              setDialogEditar(false)
            }
            disabled={salvandoCadastro}
          >
            Cancelar
          </Button>


          <Button
            variant="contained"
            onClick={() =>
              executarSalvamento(
                salvarEdicao
              )
            }
            disabled={salvandoCadastro}
          >
            {salvandoCadastro
              ? "Salvando..."
              : "Salvar"}
          </Button>

        </DialogActions>

      </Dialog>


      {/* =====================================================
          DIALOG NOVO / EDITAR FUNCIONÁRIO
      ===================================================== */}

      <Dialog
        open={dialogFuncionario}
        onClose={() =>
          !salvandoCadastro &&
          setDialogFuncionario(false)
        }
        fullWidth
        maxWidth="sm"
      >

        <DialogTitle>

          {modoEdicao
            ? "Editar Cadastro"
            : "Novo Funcionário / Prestador de Serviço"}

        </DialogTitle>


        <DialogContent>

          {/* =================================================
              TIPO
          ================================================= */}

          <TextField
            select
            label="Tipo de Cadastro"
            fullWidth
            margin="dense"
            value={
              novoFuncionario.tipo
            }
            onChange={(e) =>
              setNovoFuncionario({
                ...novoFuncionario,
                tipo: e.target.value
              })
            }
          >

            <MenuItem value="funcionario">
              Funcionário
            </MenuItem>

            <MenuItem value="prestador">
              Prestador de Serviço
            </MenuItem>

          </TextField>


          {/* =================================================
              NOME
          ================================================= */}

          <TextField
            label="Nome"
            fullWidth
            margin="dense"
            value={
              novoFuncionario.nome
            }
            onChange={(e) =>
              setNovoFuncionario({
                ...novoFuncionario,
                nome: e.target.value
              })
            }
          />


          {/* =================================================
              CARGO
          ================================================= */}

          <TextField
            label="Cargo"
            fullWidth
            margin="dense"
            value={
              novoFuncionario.cargo
            }
            onChange={(e) =>
              setNovoFuncionario({
                ...novoFuncionario,
                cargo: e.target.value
              })
            }
          />


          {/* =================================================
              FUNCIONÁRIO
          ================================================= */}

          {novoFuncionario.tipo ===
          "funcionario" ? (

            <>

              <TextField
                label="Data de Nascimento"
                type="date"
                fullWidth
                margin="dense"
                InputLabelProps={{
                  shrink: true
                }}
                value={novoFuncionario.dataNascimento}
                onChange={(e) =>
                  setNovoFuncionario({
                    ...novoFuncionario,
                    dataNascimento: e.target.value
                  })
                }
              />

              <TextField
                select
                label="Usuário vinculado (opcional)"
                fullWidth
                margin="dense"
                value={novoFuncionario.usuarioId}
                onChange={(e) =>
                  setNovoFuncionario({
                    ...novoFuncionario,
                    usuarioId: e.target.value
                  })
                }
              >
                <MenuItem value="">Nenhum usuário</MenuItem>
                {usuarios.map(usuarioItem => (
                  <MenuItem key={usuarioItem.id} value={usuarioItem.id}>
                    {usuarioItem.nome || usuarioItem.email || usuarioItem.id}
                    {usuarioItem.email ? ` — ${usuarioItem.email}` : ""}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                label="Data de Admissão"
                type="date"
                fullWidth
                margin="dense"
                InputLabelProps={{
                  shrink: true
                }}
                value={
                  novoFuncionario.dataAdmissao
                }
                onChange={(e) =>
                  setNovoFuncionario({
                    ...novoFuncionario,
                    dataAdmissao:
                      e.target.value
                  })
                }
              />


              <TextField
                label="Data de Demissão"
                type="date"
                fullWidth
                margin="dense"
                InputLabelProps={{
                  shrink: true
                }}
                value={
                  novoFuncionario.dataDemissao
                }
                onChange={(e) =>
                  setNovoFuncionario({
                    ...novoFuncionario,
                    dataDemissao:
                      e.target.value
                  })
                }
              />

            </>

          ) : (

            /* ===============================================
               PRESTADOR
            =============================================== */

            <>

              <TextField
                label="Período Inicial"
                type="date"
                fullWidth
                margin="dense"
                InputLabelProps={{
                  shrink: true
                }}
                value={
                  novoFuncionario.periodoInicial
                }
                onChange={(e) =>
                  setNovoFuncionario({
                    ...novoFuncionario,
                    periodoInicial:
                      e.target.value
                  })
                }
              />


              <TextField
                label="Período Final"
                type="date"
                fullWidth
                margin="dense"
                InputLabelProps={{
                  shrink: true
                }}
                value={
                  novoFuncionario.periodoFinal
                }
                onChange={(e) =>
                  setNovoFuncionario({
                    ...novoFuncionario,
                    periodoFinal:
                      e.target.value
                  })
                }
              />

            </>

          )}

        </DialogContent>


        <DialogActions>

          <Button
            onClick={() =>
              setDialogFuncionario(false)
            }
            disabled={salvandoCadastro}
          >
            Cancelar
          </Button>


          <Button
            variant="contained"
            onClick={() =>
              executarSalvamento(
                salvarFuncionario
              )
            }
            disabled={salvandoCadastro}
          >
            {salvandoCadastro
              ? "Salvando..."
              : "Salvar"}
          </Button>

        </DialogActions>

      </Dialog>

    </Box>
  );
}
